<template>
	<div
		class="indicator_report_title_header"
		:class="{
            borderTop: borderTop,
            borderBottom: borderBottom
        }"
	>
		<div class="time_card">
			<div class="label">{{title}}</div>
			<div v-if="label" class="value" @click="selectTime"> {{ label }}<van-icon name="arrow-down" /> </div>
		</div>
		<div class="char_drop_list" v-if="textType.length>0">
			<span v-for="(item,index) in textType" :key="index">
				{{item.label}}<span class="dian" :style="`color: ${item.color}`">•</span>
			</span>
		</div>
	</div>
</template>
<script>
export default {
    name: 'indicatorReportTitle',
    props: {
        label: {
            type: String,
            default: ''
        },
        borderTop: {
            type: Boolean,
            default: true
        },
        borderBottom: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ''
        },
        textType: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        selectTime () {
            this.$emit('labelSelect')
        }
    }
}
</script>
<style lang="less" scoped>
.borderTop {
	border-top: 1px solid #eeeeee;
}
.borderBottom {
	border-bottom: 1px solid #eeeeee;
}
.indicator_report_title {
	&_header {
		padding: 26px 0 34px 0;
		.time_card {
			display: flex;
			align-items: center;
			justify-content: space-between;
			.label {
				font-size: 34px;
				color: #000000;
				font-weight: bold;
			}
			.value {
				display: inline-block;
				background-color: #f7f7f7;
				border-radius: 6px;
				padding: 0 12px;
				font-size: 28px;
				color: @gray-9;
				height: 55px;
				line-height: 55px;
			}
		}
		.char_drop_list {
			font-size: 24px;
			color: @gray-9;
			margin-top: 18px;
			.dian {
				margin-right: 34px;
				margin-left: 10px;
			}
		}
	}
}
</style>
